import GuidePage from "@/components/guide-page";

export default function GuideHurricanePrep() {
  return (
    <GuidePage
      eyebrow="Free Guide · Tallahassee Lassie"
      title="Hurricane & Storm Prep for Tallahassee Pet Parents"
      metaTitle="Hurricane & Storm Prep for Pets in Tallahassee"
      metaDescription="A Leon County hurricane-season checklist for pet parents: build a pet go-bag, keep microchips and records current, plan your evacuation with pets, and arrange care when you can't be home."
      path="/resources/hurricane-prep"
      heroImg="https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/16617bc9-4b44-4480-8f95-5470f189f37e/IMG_4166_jpg.jpg"
      intro="North Florida sits squarely in hurricane country, and storm season runs June through November. A little prep now means you won't be scrambling when a warning hits. Use this checklist to make sure your whole household — pets included — is ready well before a storm is in the forecast."
      sections={[
        {
          heading: "Build a pet go-bag (before the season)",
          checklist: [
            "5–7 days of food in a waterproof container, plus a manual can opener.",
            "5–7 days of bottled water and a travel bowl.",
            "Any medications, plus a few extra days' supply.",
            "Collapsible crate or carrier for each pet.",
            "Leash, harness, waste bags, litter and a small pan for cats.",
            "Comfort items — a familiar blanket or toy.",
            "Recent photo of you with your pet (proof of ownership if you're separated).",
          ],
        },
        {
          heading: "Keep ID and records current",
          body: "In the chaos of a storm, ID is how pets get home. Make sure your pet wears a collar tag with a current phone number, and confirm your microchip registration shows your latest contact info. Keep a folder (paper and a photo on your phone) with vaccination records and your vet's number — many boarding facilities and shelters require proof of vaccines.",
        },
        {
          heading: "Know your evacuation plan — with pets",
          checklist: [
            "Identify pet-friendly hotels along your evacuation route ahead of time.",
            "Note that not all emergency shelters accept pets — check Leon County's current pet-friendly shelter list before a storm.",
            "Never leave a pet behind or chained outside during an evacuation.",
            "Keep carriers easily accessible, not buried in a closet or attic.",
          ],
        },
        {
          heading: "If you have to leave and can't take them",
          body: "Sometimes work or travel means you can't be home when weather turns. Line up a trusted, insured pet sitter in advance who knows your pet and your home — and who has a plan for power outages and changing conditions. The worst time to find care is the day a storm forms.",
        },
        {
          heading: "During and after the storm",
          checklist: [
            "Keep pets leashed or crated — storms disorient them and familiar landmarks may be gone.",
            "Watch for downed lines, debris, and standing water on walks afterward.",
            "Re-check fences and gates before letting dogs into the yard unsupervised.",
            "Stick to routine as much as possible — it helps anxious pets settle.",
          ],
        },
        {
          heading: "How we help during storm season",
          body: "As a fully bonded and insured local team, we help current clients with care during evacuations and unpredictable weather whenever we safely can. If hurricane season has you thinking ahead, let's get a plan in place before you need it.",
        },
      ]}
      ctaHeading="Want a storm-season backup plan for your pet?"
      ctaBody="Let's set up trusted care before hurricane season heats up. Book a free call and we'll talk through your plan."
    />
  );
}
